import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { OutputAttribute } from 'app/private/sxfdesigner/types/designer-attribute-type';
import { Translator } from 'angular-translator';
import {
  RULE,
  TYPE,
  PAGE,
  FLOW,
} from 'app/infrastructure/model/constants/outputViewEngineConstants.constant';

@Component({
  selector: 'outputs-view-engine-tab',
  templateUrl: './outputs-view-engine.component.html',
})
export class OutputsViewEngineComponent implements OnInit, OnDestroy {
  @Input() outputAtt: OutputAttribute[];
  @Output() onNewRule: EventEmitter<string> = new EventEmitter<string>();
  _outputObject: OutputAttribute;
  selectionsContainer = [];

  constructor(private translate: Translator) {}

  ngOnInit() {
    this._outputObject = this.outputAtt[0];
    this.selectOption();
  }

  ngOnDestroy() {
    this._outputObject = <OutputAttribute>{};
  }

  selectOption() {
    for (let name in this._outputObject.value) {
      if (name === 'attributeSyncher' || name === 'tokenCaptcha')
        delete this._outputObject.value[name];
      else {
        let container = {
          name: name,
          outputTypes: this._outputObject.ouputTypes,
          ruleOptions: this._outputObject.ruleOptions,
          pageOptions: this._outputObject.pageOptions,
          flowOptions: this._outputObject.flowOptions,
        };
        this.selectionsContainer.push(container);
      }
    }
  }

  showSelectOptionRule(output) {
    if (this._outputObject.value[output.name][TYPE]) {
      let outputType = this._outputObject.value[output.name][TYPE];
      if (
        outputType === 'nonBlockingCall' ||
        outputType === 'interationRuleEvent' ||
        outputType === 'quoteGrid'
      )
        return true;
    }
  }

  showSelectOptionPage(output) {
    if (this._outputObject.value[output.name][TYPE]) {
      let outputType = this._outputObject.value[output.name][TYPE];
      if (outputType === 'navigateToPage') return true;
    }
  }

  showSelectOptionFlow(output) {
    if (this._outputObject.value[output.name][TYPE]) {
      let outputType = this._outputObject.value[output.name][TYPE];
      if (outputType === 'navigateToFlow' || outputType === 'launchTransaction')
        return true;
    }
  }

  onChangeOption(nameOutput, outputType, childOutputType) {
    this.addValueToObject(nameOutput, outputType, childOutputType);
  }

  addValueToObject(nameOutput, outputType, childOutputType) {
    if (childOutputType) {
      this._outputObject.value[nameOutput][childOutputType] = outputType;
    } else {
      this._outputObject.value[nameOutput][TYPE] = outputType;
      this.deleteChildSelection(nameOutput);
    }
  }
  deleteChildSelection(nameOutput) {
    delete this._outputObject.value[nameOutput][RULE];
    delete this._outputObject.value[nameOutput][PAGE];
    delete this._outputObject.value[nameOutput][FLOW];
  }

  newRule(name: string) {
    this.onNewRule.emit(name);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/modals/view-engine/tabs/outputs/outputs-view-engine.component.ts